import { render, staticRenderFns } from "./LocalizacaoVendedor.vue?vue&type=template&id=aff4ace2&scoped=true"
import script from "./LocalizacaoVendedor.vue?vue&type=script&lang=js"
export * from "./LocalizacaoVendedor.vue?vue&type=script&lang=js"
import style0 from "./LocalizacaoVendedor.vue?vue&type=style&index=0&id=aff4ace2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff4ace2",
  null
  
)

export default component.exports